/**
 * WARNING: This component is auto-generated by the build script in the parent directory.
 * Do not edit this file, as any changes will be overwritten. Instead, edit the template and
 * svg files to make changes
 */
import React from "react";
import classNames from "classnames";
import { IIconProps, IconSize } from "../types";

const Frame = (props: IIconProps): React.ReactElement => {
  const { className, size = IconSize.Medium, ...rest } = props;
  const iconClass = classNames("kl-icon", `kl-icon--${size}`, className);
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    <path d="M10 8v1H7v3H6V8h4zM18.001 16v-4h-1v3h-3v1h4z" />,
    <path
      fillRule="evenodd"
      d="M.654 4A1.98 1.98 0 00.52 5.121L.94 6.64a2 2 0 01-.012.72l-.614 3.073a8 8 0 000 3.136l.614 3.073a2 2 0 01.012.72L.52 18.88A1.98 1.98 0 00.654 20c.246.566.746.995 1.346 1.148.327.084.683.086 1.042-.017l2.069-.877a2 2 0 011.659.259l1.12.747a2 2 0 002.22 0l.78-.52a2 2 0 012.22 0l.78.52a2 2 0 002.22 0l1.12-.747a2 2 0 011.66-.259l2.068.877c.36.103.716.1 1.042.017.6-.153 1.1-.582 1.346-1.148a1.98 1.98 0 00.134-1.121l-.42-1.517a2 2 0 01.012-.721l.614-3.072a8.001 8.001 0 000-3.138l-.614-3.072a2 2 0 01-.012-.72l.42-1.518A1.98 1.98 0 0023.346 4 2.022 2.022 0 0022 2.852a1.983 1.983 0 00-1.042.017l-2.069.877a2 2 0 01-1.659-.259l-1.12-.747a2 2 0 00-2.22 0l-.78.52a2 2 0 01-2.22 0l-.78-.52a2 2 0 00-2.22 0l-1.12.747a2 2 0 01-1.66.259l-2.068-.877A1.984 1.984 0 002 2.852C1.4 3.005.9 3.434.654 4zM20 6H4v12h16V6z"
      clipRule="evenodd"
    />,
  );
};

export default Frame;
